import { render, staticRenderFns } from "./EfsStdMarginModal.vue?vue&type=template&id=506332ba&scoped=true&"
import script from "./EfsStdMarginModal.vue?vue&type=script&lang=js&"
export * from "./EfsStdMarginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506332ba",
  null
  
)

export default component.exports